(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Header bar plus its menu drawer.
   *
   * The drawer is a native <dialog> opened with showModal(), so focus trapping,
   * Escape and inertness come from the platform. `scroll-lock` is picked up by
   * the rule in critical.css that freezes the page behind it.
   */
  class LclHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('dialog');
      this.trigger = null;
      this.ticking = false;

      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.handleScroll();

      if (!this.drawer) return;

      this.querySelectorAll('[data-drawer-open]').forEach((button) => {
        button.addEventListener('click', () => this.open(button));
      });

      this.querySelectorAll('[data-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => this.drawer.close());
      });

      // Clicking the backdrop resolves to the dialog element itself.
      this.drawer.addEventListener('click', (event) => {
        if (event.target === this.drawer) this.drawer.close();
      });

      this.drawer.addEventListener('close', () => {
        this.querySelectorAll('[data-drawer-open]').forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
        if (this.trigger) {
          this.trigger.focus();
          this.trigger = null;
        }
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    open(trigger) {
      this.trigger = trigger || null;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      this.drawer.showModal();
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.classList.toggle('is-stuck', window.scrollY > 8);
        this.ticking = false;
      });
    }
  }

  if (!customElements.get('lcl-header')) customElements.define('lcl-header', LclHeader);

  } catch(e) { console.error(e); }
})();
})();
